function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { attachSubComponents } from '../../util';
import { InnerBadge } from './InnerBadge/InnerBadge';
import { styled } from 'styled-components';
import { InlineBadge } from './InnerBadge/Inline';
const BadgeContainer = styled.div.withConfig({
  componentId: "aui__sc-1qu6bu9-0"
})(["position:relative;width:min-content;"]);
export const Badge = attachSubComponents('Badge', /*#__PURE__*/React.forwardRef(({
  size = 'hint',
  overlap = 'circular',
  children,
  position = 'bottom-right',
  variant = 'notification',
  iconSrc,
  count,
  ...props
}, fRef) => /*#__PURE__*/React.createElement(BadgeContainer, _extends({
  ref: fRef,
  "data-aui": "badge"
}, props), /*#__PURE__*/React.createElement(InnerBadge, {
  position: position,
  size: size,
  overlap: overlap,
  variant: variant,
  iconSrc: iconSrc,
  count: count
}), children)), {
  Inline: InlineBadge
});